import { NgModule } from '@angular/core';

import { LIB_CommonModule } from "pbc.angular";

import { ReisekostenabrechnungService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [
    ReisekostenabrechnungService,
  ],
  exports: []
})
export class ReisekostenabrechnungServiceModule { }
